import React, { useEffect, useState } from "react";
import { close } from "../../assets/images/icons";
import parse from "html-react-parser";
import "./modal.scss";

const Modal = ({
  showModal = false,
  setShowModal,
  children,
  title,
  wrapperClassname = "",
  onClose = () => {},
}) => {
  return (
    showModal && (
      <>
        <div
          className="modalBackdrop"
          onClick={() => {
            setShowModal(false);
            onClose();
          }}
        ></div>
        <div
          className={`modalContainer ${wrapperClassname}`}
        >
          <div className="modalHeader">
            <span className="modalTitle">{title}</span>
            <span
              onClick={() => {
                setShowModal(false);
                onClose();
              }}
            >
              {parse(close)}
            </span>
          </div>
          {children}
        </div>
      </>
    )
  );
};

export default Modal;
